import React, { Component } from 'react';
import map from 'lodash.map';
import { ActElementPodpis } from './ActElementPodpis';
import orderBy from 'lodash.orderby';

export class ActElementPodpisy extends Component {
	render() {
		const {
			childrens,
			agreementAccepted = false,
			agreementAcceptedRequired = false,
			scrollToAgreement = Function.prototype,
			userId,
			isCommentAdding = false
		} = this.props;

		return (
			<div className="act__sign">
				{map(
					orderBy(childrens, (c) => c.order),
					(child) =>
						child.name === 'podpis' ? (
							<ActElementPodpis
								{...child}
								agreementAccepted={agreementAccepted}
								agreementAcceptedRequired={agreementAcceptedRequired}
								scrollToAgreement={scrollToAgreement}
								userId={userId}
								isCommentAdding={isCommentAdding}
							/>
						) : (
							<div />
						)
				)}
			</div>
		);
	}
}
